define.alias("shared/components/shared/pre-boarding/sourceless-trial-end/index", "calendar/components/shared/pre-boarding/sourceless-trial-end/index");